export default __webpack_public_path__ + "fonts/proximanova-bold.woff2";